import React, { useEffect, useRef, useState } from "react";
import { baseUrl, config } from "../../../services/config";
import { Paper } from "@material-ui/core";
import { Spinner, Table } from "react-bootstrap";
import { useAlert } from "react-alert";
import ReactToPrint from "react-to-print";
import { upperCase } from "lodash";
import { DatePicker } from "antd";
import { DownloadTableExcel } from "react-export-table-to-excel";
const { RangePicker } = DatePicker;

const MonthlyRecovery = () => {
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [sessionName, setSessionName] = useState("");
  const [debitSum, setDebitSum] = useState(0);
  const [creditSum, setCreditSum] = useState(0);
  const [lossDebited, setLossDebited] = useState(0);
  const [profitCredited, setProfitCredited] = useState(0);
  const [viewModal, setViewModal] = useState(false);
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);

  const [startDate, setStartDate] = useState("");
  const [endDate, setendDate] = useState("");

  const [netCashFlow, setNetCashFlow] = useState({});
  const [balance, setBalance] = useState([]);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);
  let authtoken = localStorage.getItem("userToken");
  const alert = useAlert();

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);
  const tableRef = useRef(null);
  const pageStyle = `
  @page {
    size: a4 !important;
  }
  `;

  const labels = {
    revenue: "Revenue",
    asset: "Asset",
    expenses: "Expenses",
    net: "Net cash flow (Revenue − Asset − Expenses)",
  };

  useEffect(() => {
    getSettingData();
    sessions();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
            setSessionName(session.year);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const datePicker = (value, dateString) => {
    console.log("Formatted Selected Time: ", dateString);
    setStartDate(dateString[0]);
    setendDate(dateString[1]);
  };

  const handleGetData = () => {
    // if (yearId == "") {
    //   alert.error("Please select the year");
    //   return;
    // }

    setLoading(true);
    setIsVisible(false);

    const data = {
      //   year_id: yearId,
      start_date: startDate,
      end_date: endDate,
    };
    fetch(`${baseUrl}/monthly-recovery-report`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setIsVisible(true);
        if (data.payload) {
          console.log("result", data.payload);
          setReportData(data.payload);
          //   setNetCashFlow(data.payload.net_cash_flow_breakdown);
          //   setBalance(data.payload.closing_balance_summary);
          // setCreditSum(data.payload.conclusion?.grand_total_credit);
          // setDebitSum(data.payload.conclusion?.grand_total_debit);
          // setLossDebited(data.payload.conclusion?.loss_debited);
          // setProfitCredited(data.payload.conclusion?.profit_credited);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("err is re", err);
      });
  };
  //for print
  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
  }, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    console.log("`onBeforeGetContent` called");
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const calckNumberDebit = (data) => {
    const totalDebit = data.reduce((a, c) => a + parseInt(c.debit), 0);
    const totalCredit = data.reduce((a, c) => a + parseInt(c.credit), 0);
    if (totalDebit > totalCredit) {
      return Number(totalDebit) - Number(totalCredit);
    } else {
      return 0;
    }
  };
  const calckNumberCredit = (data) => {
    const totalDebit = data.reduce((a, c) => a + parseInt(c.debit), 0);
    const totalCredit = data.reduce((a, c) => a + parseInt(c.credit), 0);
    if (totalCredit > totalDebit) {
      return Number(totalCredit) - Number(totalDebit);
    } else {
      return 0;
    }
  };

  const mainNumberCalc = (data) => {
    let totalDebit = 0;
    let totalCredit = 0;
    data.map((item) => {
      item.sub_account.map((last) => {
        totalDebit += parseInt(last.debit);
      });
      item.sub_account.map((last) => {
        totalCredit += parseInt(last.credit);
      });
    });
    if (totalDebit > totalCredit) {
      return `Total Loss: ${totalDebit - totalCredit}`;
    } else {
      return `Total Profit: ${totalCredit - totalDebit}`;
    }
  };

  return (
    <>
      <Paper
        style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
      >
        <div className="row">
          {/* <div className="col-md-3">
            <label>
              <b>Select Session</b>
            </label>
            <div className="d-flex flex-column ">
              <select
                style={{ height: 40 }}
                className="form-select"
                name="year_id"
                value={yearId}
                aria-label="Default select example"
                onChange={(e) => {
                  const data = sessionData.find((ses) => {
                    return ses.id == e.target.value;
                  });
                  setSessionName(data.year);
                  setYearId(e.target.value);
                }}
              >
                <option value="">Select Session</option>
                {sessionData &&
                  sessionData.map((item) => (
                    <option value={item.id}>{item.year}</option>
                  ))}
              </select>
            </div>
          </div> */}

          <div className="col-md-4">
            <label>
              <b>Select Start & End Date</b>
            </label>
            <RangePicker
              getPopupContainer={(triggerNode) => {
                return triggerNode.parentNode;
              }}
              style={{ height: "40px", width: "100%" }}
              onChange={datePicker}
            />
          </div>
          <div className="col-md-4 mt-9">
            <button className="btn btn-primary mx-2" onClick={handleGetData}>
              Show
            </button>
            {isVisible ? (
              <>
                <ReactToPrint
                  documentTitle={`Monthly Recovery Report`}
                  pageStyle={pageStyle}
                  onAfterPrint={handleAfterPrint}
                  onBeforeGetContent={handleOnBeforeGetContent}
                  onBeforePrint={handleBeforePrint}
                  removeAfterPrint={true}
                  trigger={() => (
                    <button
                      disabled={printloading ? true : false}
                      className="btn btn-primary w-25 mx-2"
                    >
                      {printloading ? <span>Printing..</span> : "Print"}
                    </button>
                  )}
                  content={() => componentRef.current}
                />

                <DownloadTableExcel
                  filename="Monthly Recovery"
                  sheet="CashFlow"
                  currentTableRef={tableRef.current}
                >
                  <button className="btn btn-primary mx-2"> Export </button>
                </DownloadTableExcel>
              </>
            ) : null}
          </div>
        </div>

        <div className="mt-5">
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Spinner class="text-center" variant="info" animation="border" />
            </div>
          ) : isVisible ? (
            <div id="tableboot mt-4">
              <div className="d-flex">
                <div>
                  <img
                    style={{ height: 100, width: 110 }}
                    src={icon}
                    alt="logo"
                  />
                </div>
                <div className="mx-5" style={{ paddingTop: "10px" }}>
                  <h1>{unitName}</h1>
                  <h3>
                    Monthly Recovery For The Financial Year {sessionName} Till
                    Date {date}
                  </h3>
                </div>
              </div>

              <div
                className="text-center text-color-primary mt-5 p-2"
                style={{
                  fontSize: "1.5rem",
                  border: "2px solid black",
                  fontWeight: "bold",
                }}
              >
                <span>{reportData?.revenue?.length > 0 && "Revenue"}</span>
              </div>
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th
                      className="text-center text-dark p-2"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      A/C Code
                    </th>
                    <th
                      className="text-start text-dark p-2 pl-10"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      Account Name
                    </th>
                    <th
                      className="text-center text-dark p-2"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <React.Fragment>
                    {reportData?.revenue &&
                      reportData?.revenue.map((subItem, subIndex) =>
                        reportData?.revenue?.length > 0 ? (
                          <React.Fragment key={subIndex}>
                            <tr id="tbl">
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>{subItem?.account_chart_acode}</b>
                              </td>
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>{subItem?.account_chart_title}</b>
                              </td>
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>
                                  {Intl.NumberFormat("en-Us").format(
                                    subItem?.total,
                                  )}
                                </b>
                              </td>
                            </tr>
                            {subItem?.sub_accounts?.length > 0 &&
                              subItem?.sub_accounts.map(
                                (subSubItem, subSubIndex) => (
                                  <React.Fragment key={subSubIndex}>
                                    <tr id="tbl">
                                      <td
                                        className="text-end text-dark pr-10"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {subSubItem?.sub_account_acode}
                                      </td>
                                      <td
                                        className="text-end text-dark pr-10"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {subSubItem?.sub_account_name}
                                      </td>
                                      <td
                                        className="text-center text-dark"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {Intl.NumberFormat("en-Us").format(
                                          subSubItem?.amount,
                                        )}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ),
                              )}
                          </React.Fragment>
                        ) : null,
                      )}
                    <tr id="tbl">
                      <td
                        style={{
                          color: "black",
                          paddingLeft: "30px",
                        }}
                        className="text-start"
                      ></td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "1.2rem",
                          border: "2px solid black",
                          padding: "1px",
                          whiteSpace: "normal",
                        }}
                        className="text-end pr-10"
                      >
                        Grand Total :-
                      </td>

                      <td
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          border: "2px solid black",
                          fontSize: "1.2rem",
                          padding: "1px",
                          whiteSpace: "normal",
                        }}
                        className="text-center"
                      >
                        {Intl.NumberFormat("en-Us").format(
                          reportData?.revenue?.reduce(
                            (accumulator, currentValue) =>
                              accumulator + currentValue?.total,
                            0,
                          ),
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                </tbody>
              </Table>

              <div
                className="text-center text-color-primary mt-8 p-2"
                style={{
                  fontSize: "1.5rem",
                  border: "2px solid black",
                  fontWeight: "bold",
                }}
              >
                <span>{reportData?.expenses?.length > 0 && "Expenses"}</span>
              </div>
              <Table responsive>
                <thead>
                  <tr id="tbl">
                    <th
                      className="text-center text-dark p-2"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      A/C Code
                    </th>
                    <th
                      className="text-start text-dark p-2 pl-10"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      Account Name
                    </th>
                    <th
                      className="text-center text-dark p-2"
                      style={{
                        fontSize: "1.2rem",
                        border: "1px solid black",
                        whiteSpace: "normal",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <React.Fragment>
                    {reportData?.expenses &&
                      reportData?.expenses.map((subItem, subIndex) =>
                        reportData?.expenses?.length > 0 ? (
                          <React.Fragment key={subIndex}>
                            <tr id="tbl">
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>{subItem?.account_chart_acode}</b>
                              </td>
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>{subItem?.account_chart_title}</b>
                              </td>
                              <td
                                className="text-center text-dark"
                                style={{
                                  fontSize: "1.2rem",
                                  border: "1px solid black",
                                  padding: "1px",
                                  whiteSpace: "normal",
                                }}
                              >
                                <b>
                                  {Intl.NumberFormat("en-Us").format(
                                    subItem?.total,
                                  )}
                                </b>
                              </td>
                            </tr>
                            {subItem?.sub_accounts?.length > 0 &&
                              subItem?.sub_accounts.map(
                                (subSubItem, subSubIndex) => (
                                  <React.Fragment key={subSubIndex}>
                                    <tr id="tbl">
                                      <td
                                        className="text-end text-dark pr-10"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {subSubItem?.sub_account_acode}
                                      </td>
                                      <td
                                        className="text-end text-dark pr-10"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {subSubItem?.sub_account_name}
                                      </td>
                                      <td
                                        className="text-center text-dark"
                                        style={{
                                          fontSize: "1.1rem",
                                          border: "1px solid black",
                                          padding: "1px",
                                          whiteSpace: "normal",
                                        }}
                                      >
                                        {Intl.NumberFormat("en-Us").format(
                                          subSubItem?.amount,
                                        )}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                ),
                              )}
                          </React.Fragment>
                        ) : null,
                      )}
                    <tr id="tbl">
                      <td
                        style={{
                          color: "black",
                          paddingLeft: "30px",
                        }}
                        className="text-start"
                      ></td>
                      <td
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          fontSize: "1.2rem",
                          border: "2px solid black",
                          padding: "1px",
                          whiteSpace: "normal",
                        }}
                        className="text-end pr-10"
                      >
                        Grand Total :-
                      </td>

                      <td
                        style={{
                          color: "black",
                          fontWeight: "bold",
                          border: "2px solid black",
                          padding: "1px",
                          whiteSpace: "normal",
                          fontSize: "1.2rem",
                        }}
                        className="text-center"
                      >
                        {Intl.NumberFormat("en-Us").format(
                          reportData?.expenses?.reduce(
                            (accumulator, currentValue) =>
                              accumulator + currentValue?.total,
                            0,
                          ),
                        )}
                      </td>
                    </tr>
                  </React.Fragment>
                </tbody>
              </Table>
            </div>
          ) : null}
        </div>
      </Paper>

      <div
        ref={componentRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot mt-4">
          <div className="d-flex">
            <div className="">
              <img
                style={{ height: 100, width: 110, paddingLeft: "20px" }}
                src={icon}
                alt="logo"
              />
            </div>
            <div className="mx-5" style={{ paddingTop: "10px" }}>
              <h1>{unitName}</h1>
              <h3>
                Cash Flow For The Financial Year {sessionName} Till Date {date}
              </h3>
            </div>
          </div>
          <div
            className="text-center text-color-primary mt-5 p-2"
            style={{
              fontSize: "1.5rem",
              border: "2px solid black",
              fontWeight: "bold",
            }}
          >
            <span>{reportData?.revenue?.length > 0 && "Revenue"}</span>
          </div>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  A/C Code
                </th>
                <th
                  className="text-start text-dark p-2 pl-10"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Account Name
                </th>
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              <React.Fragment>
                {reportData?.revenue &&
                  reportData?.revenue.map((subItem, subIndex) =>
                    reportData?.revenue?.length > 0 ? (
                      <React.Fragment key={subIndex}>
                        <tr id="tbl">
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_acode}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_title}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>
                              {Intl.NumberFormat("en-Us").format(
                                subItem?.total,
                              )}
                            </b>
                          </td>
                        </tr>
                        {subItem?.sub_accounts?.length > 0 &&
                          subItem?.sub_accounts.map(
                            (subSubItem, subSubIndex) => (
                              <React.Fragment key={subSubIndex}>
                                <tr id="tbl">
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_acode}
                                  </td>
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_name}
                                  </td>
                                  <td
                                    className="text-center text-dark"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subSubItem?.amount,
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ),
                          )}
                      </React.Fragment>
                    ) : null,
                  )}
                <tr id="tbl">
                  <td
                    style={{
                      color: "black",
                      paddingLeft: "30px",
                    }}
                    className="text-start"
                  ></td>
                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-end pr-10"
                  >
                    Grand Total :-
                  </td>

                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      border: "2px solid black",
                      fontSize: "1.2rem",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-center"
                  >
                    {Intl.NumberFormat("en-Us").format(
                      reportData?.revenue?.reduce(
                        (accumulator, currentValue) =>
                          accumulator + currentValue?.total,
                        0,
                      ),
                    )}
                  </td>
                </tr>
              </React.Fragment>
            </tbody>
          </Table>

          <div
            className="text-center text-color-primary mt-8 p-2"
            style={{
              fontSize: "1.5rem",
              border: "2px solid black",
              fontWeight: "bold",
            }}
          >
            <span>{reportData?.expenses?.length > 0 && "Expenses"}</span>
          </div>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  A/C Code
                </th>
                <th
                  className="text-start text-dark p-2 pl-10"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Account Name
                </th>
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              <React.Fragment>
                {reportData?.expenses &&
                  reportData?.expenses.map((subItem, subIndex) =>
                    reportData?.expenses?.length > 0 ? (
                      <React.Fragment key={subIndex}>
                        <tr id="tbl">
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_acode}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_title}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>
                              {Intl.NumberFormat("en-Us").format(
                                subItem?.total,
                              )}
                            </b>
                          </td>
                        </tr>
                        {subItem?.sub_accounts?.length > 0 &&
                          subItem?.sub_accounts.map(
                            (subSubItem, subSubIndex) => (
                              <React.Fragment key={subSubIndex}>
                                <tr id="tbl">
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_acode}
                                  </td>
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_name}
                                  </td>
                                  <td
                                    className="text-center text-dark"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subSubItem?.amount,
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ),
                          )}
                      </React.Fragment>
                    ) : null,
                  )}
                <tr id="tbl">
                  <td
                    style={{
                      color: "black",
                      paddingLeft: "30px",
                    }}
                    className="text-start"
                  ></td>
                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-end pr-10"
                  >
                    Grand Total :-
                  </td>

                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                      fontSize: "1.2rem",
                    }}
                    className="text-center"
                  >
                    {Intl.NumberFormat("en-Us").format(
                      reportData?.expenses?.reduce(
                        (accumulator, currentValue) =>
                          accumulator + currentValue?.total,
                        0,
                      ),
                    )}
                  </td>
                </tr>
              </React.Fragment>
            </tbody>
          </Table>

          {/* <h3 className="mt-8 text-center text-color-primary font-weight-bold">
            Net Cash Flow
          </h3>
          <div className="border border-dark p-4">
            <Table className="mt-2" responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Name
                  </th>
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {Object.entries(netCashFlow).map(([key, value]) => {
                  const isNet = key === "net";
                  return (
                    <tr key={key} id="tbl">
                      <td
                        className="text-center text-capitalize"
                        style={{
                          fontSize: "18px",
                          whiteSpace: "normal",
                          padding: "1px",
                          color: "black",
                          borderTop: isNet ? "2px solid black" : "",
                          borderBottom: isNet ? "2px solid black" : "",
                        }}
                      >
                        {labels[key] || key.replaceAll("_", " ")}
                      </td>

                      <td
                        className="text-center"
                        style={{
                          color: "black",
                          fontSize: "18px",
                          whiteSpace: "normal",
                          padding: "1px",
                          borderTop: isNet ? "2px solid black" : "",
                          borderBottom: isNet ? "2px solid black" : "",
                        }}
                      >
                        {Intl.NumberFormat("en-US").format(value)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          <h3 className="mt-8 text-center text-color-primary font-weight-bold">
            Balance
          </h3>
          <div className="border border-dark p-4">
            <Table className="mt-2" responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Name
                  </th>
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Opening Balance
                  </th>
                  <th className="text-center" style={{ fontSize: "18px" }}>
                    Closing Balance
                  </th>
                </tr>
              </thead>

              <tbody>
                {balance.map((value, index) => (
                  <tr key={index} id="tbl">
                    <td
                      className="text-center text-capitalize"
                      style={{
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {value.label}
                    </td>

                    <td
                      className="text-center"
                      style={{
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {Intl.NumberFormat("en-US").format(value.opening)}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        color: "black",
                        fontSize: "18px",
                        whiteSpace: "normal",
                        padding: "1px",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {Intl.NumberFormat("en-US").format(value.closing)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div> */}
        </div>
      </div>

      <div
        ref={tableRef}
        id="printSection"
        style={{ visibility: "hidden" }}
        className="tablePrint"
      >
        <div id="tableboot ">
          <div className="d-flex">
            <div className="mx-5" style={{ paddingTop: "10px" }}>
              <h1>{unitName}</h1>
              <h3>
                Cash Flow For The Financial Year {sessionName} Till Date {date}
              </h3>
            </div>
          </div>
          <div
            className="text-center text-color-primary mt-5 p-2"
            style={{
              fontSize: "1.5rem",
              border: "2px solid black",
              fontWeight: "bold",
            }}
          >
            <span>{reportData?.revenue?.length > 0 && "Revenue"}</span>
          </div>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  A/C Code
                </th>
                <th
                  className="text-start text-dark p-2 pl-10"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Account Name
                </th>
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              <React.Fragment>
                {reportData?.revenue &&
                  reportData?.revenue.map((subItem, subIndex) =>
                    reportData?.revenue?.length > 0 ? (
                      <React.Fragment key={subIndex}>
                        <tr id="tbl">
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_acode}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_title}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>
                              {Intl.NumberFormat("en-Us").format(
                                subItem?.total,
                              )}
                            </b>
                          </td>
                        </tr>
                        {subItem?.sub_accounts?.length > 0 &&
                          subItem?.sub_accounts.map(
                            (subSubItem, subSubIndex) => (
                              <React.Fragment key={subSubIndex}>
                                <tr id="tbl">
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_acode}
                                  </td>
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_name}
                                  </td>
                                  <td
                                    className="text-center text-dark"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subSubItem?.amount,
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ),
                          )}
                      </React.Fragment>
                    ) : null,
                  )}
                <tr id="tbl">
                  <td
                    style={{
                      color: "black",
                      paddingLeft: "30px",
                    }}
                    className="text-start"
                  ></td>
                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-end pr-10"
                  >
                    Grand Total :-
                  </td>

                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      border: "2px solid black",
                      fontSize: "1.2rem",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-center"
                  >
                    {Intl.NumberFormat("en-Us").format(
                      reportData?.revenue?.reduce(
                        (accumulator, currentValue) =>
                          accumulator + currentValue?.total,
                        0,
                      ),
                    )}
                  </td>
                </tr>
              </React.Fragment>
            </tbody>
          </Table>

          <div
            className="text-center text-color-primary mt-8 p-2"
            style={{
              fontSize: "1.5rem",
              border: "2px solid black",
              fontWeight: "bold",
            }}
          >
            <span>{reportData?.expenses?.length > 0 && "Expenses"}</span>
          </div>
          <Table responsive>
            <thead>
              <tr id="tbl">
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  A/C Code
                </th>
                <th
                  className="text-start text-dark p-2 pl-10"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Account Name
                </th>
                <th
                  className="text-center text-dark p-2"
                  style={{
                    fontSize: "1.2rem",
                    border: "1px solid black",
                    whiteSpace: "normal",
                  }}
                >
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              <React.Fragment>
                {reportData?.expenses &&
                  reportData?.expenses.map((subItem, subIndex) =>
                    reportData?.expenses?.length > 0 ? (
                      <React.Fragment key={subIndex}>
                        <tr id="tbl">
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_acode}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>{subItem?.account_chart_title}</b>
                          </td>
                          <td
                            className="text-center text-dark"
                            style={{
                              fontSize: "1.2rem",
                              border: "1px solid black",
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <b>
                              {Intl.NumberFormat("en-Us").format(
                                subItem?.total,
                              )}
                            </b>
                          </td>
                        </tr>
                        {subItem?.sub_accounts?.length > 0 &&
                          subItem?.sub_accounts.map(
                            (subSubItem, subSubIndex) => (
                              <React.Fragment key={subSubIndex}>
                                <tr id="tbl">
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_acode}
                                  </td>
                                  <td
                                    className="text-end text-dark pr-10"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {subSubItem?.sub_account_name}
                                  </td>
                                  <td
                                    className="text-center text-dark"
                                    style={{
                                      fontSize: "1.1rem",
                                      border: "1px solid black",
                                      padding: "1px",
                                      whiteSpace: "normal",
                                    }}
                                  >
                                    {Intl.NumberFormat("en-Us").format(
                                      subSubItem?.amount,
                                    )}
                                  </td>
                                </tr>
                              </React.Fragment>
                            ),
                          )}
                      </React.Fragment>
                    ) : null,
                  )}
                <tr id="tbl">
                  <td
                    style={{
                      color: "black",
                      paddingLeft: "30px",
                    }}
                    className="text-start"
                  ></td>
                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                    className="text-end pr-10"
                  >
                    Grand Total :-
                  </td>

                  <td
                    style={{
                      color: "black",
                      fontWeight: "bold",
                      border: "2px solid black",
                      padding: "1px",
                      whiteSpace: "normal",
                      fontSize: "1.2rem",
                    }}
                    className="text-center"
                  >
                    {Intl.NumberFormat("en-Us").format(
                      reportData?.expenses?.reduce(
                        (accumulator, currentValue) =>
                          accumulator + currentValue?.total,
                        0,
                      ),
                    )}
                  </td>
                </tr>
              </React.Fragment>
            </tbody>
          </Table>

          {/* <h4 className="mt-8 text-center text-color-primary">Net Cash Flow</h4>
          <div className="border border-dark p-4">
            <Table className="mt-2" responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-center">Name</th>
                  <th className="text-center">Amount</th>
                </tr>
              </thead>

              <tbody>
                {Object.entries(netCashFlow).map(([key, value]) => {
                  const isNet = key === "net";
                  return (
                    <tr key={key} id="tbl">
                      <td
                        className="text-center text-capitalize"
                        style={{
                          color: "black",
                          fontSize: "1.1rem",
                          borderTop: isNet ? "2px solid black" : "",
                          borderBottom: isNet ? "2px solid black" : "",
                        }}
                      >
                        {labels[key] || key.replaceAll("_", " ")}
                      </td>

                      <td
                        className="text-center"
                        style={{
                          color: "black",
                          fontSize: "1.1rem",
                          borderTop: isNet ? "2px solid black" : "",
                          borderBottom: isNet ? "2px solid black" : "",
                        }}
                      >
                        {Intl.NumberFormat("en-US").format(value)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>

          <h4 className="mt-8 text-center text-color-primary">Balance</h4>
          <div className="border border-dark p-4">
            <Table className="mt-2" responsive>
              <thead>
                <tr id="tbl">
                  <th className="text-center">Name</th>
                  <th className="text-center">Opening Balance</th>
                  <th className="text-center">Closing Balance</th>
                </tr>
              </thead>

              <tbody>
                {balance.map((value, index) => (
                  <tr key={index} id="tbl">
                    <td
                      className="text-center text-capitalize"
                      style={{
                        color: "black",
                        fontSize: "1.1rem",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {value.label}
                    </td>

                    <td
                      className="text-center"
                      style={{
                        color: "black",
                        fontSize: "1.1rem",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {Intl.NumberFormat("en-US").format(value.opening)}
                    </td>
                    <td
                      className="text-center"
                      style={{
                        color: "black",
                        fontSize: "1.1rem",
                        borderTop:
                          value.label == "Total" ? "2px solid black" : "",
                        borderBottom:
                          value.label == "Total" ? "2px solid black" : "",
                      }}
                    >
                      {Intl.NumberFormat("en-US").format(value.closing)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default MonthlyRecovery;
